function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols);
} return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); });
} return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
}
else {
    obj[key] = value;
} return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null)
    return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
        return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return (hint === "string" ? String : Number)(input); }
// import mspSvg from '@nordvpn/teams.core/lib/assets/img/msp-organizations.svg';
import memberSvg from '@nordvpn/teams.core/lib/assets/img/member.svg';
import reloadSvg from '@nordvpn/teams.core/lib/assets/img/reload.svg';
import serverSvg from '@nordvpn/teams.core/lib/assets/img/server.svg';
import usersSvg from '@nordvpn/teams.core/lib/assets/img/users.svg';
import { LOGOUT } from '@nordvpn/teams.core/lib/auth/constants';
import adminsSvg from 'assets/img/admins.svg';
import activitySvg from 'assets/img/calendar.svg';
import couponsSvg from 'assets/img/coupon-icon.svg';
import partnersSvg from 'assets/img/partners.svg';
import plansSvg from 'assets/img/plans.svg';
import resellersSvg from 'assets/img/resellers.svg';
import { ACTIVITY_LIST_PATH } from 'routing/routes/activity/constants';
import { COUPONS_LIST_PATH } from 'routing/routes/coupons/constants';
import { PLANS_LIST_PATH } from 'routing/routes/customPlansManagement/constants';
import { MEMBERS_LIST_PATH } from 'routing/routes/members/constants';
import { ORGANIZATIONS_LIST_PATH } from 'routing/routes/organizations/constants';
import { PARTNERS_PATH } from 'routing/routes/partners/constants';
import { REFUNDS_LIST_PATH } from 'routing/routes/refunds/constants';
import { RESELLERS_LIST_PATH } from 'routing/routes/resellers/constants';
import { SERVER_LIST_PATH } from 'routing/routes/servers/constants';
import { USERS_MANAGEMENT_PATH } from 'routing/routes/users/constants';
import { PermissionsEnum } from 'types/permissions/enums';
/** Makes the SidebarItem typing more specific to our permissions */
export var sidebarItems = [{
        title: 'Organizations',
        url: ORGANIZATIONS_LIST_PATH,
        iconSrc: usersSvg,
        permission: PermissionsEnum.ViewOrganization
    }, {
        title: 'MSP partners',
        url: PARTNERS_PATH,
        iconSrc: partnersSvg,
        permission: PermissionsEnum.ViewPartner
    }, {
        title: 'Resellers',
        url: RESELLERS_LIST_PATH,
        iconSrc: resellersSvg,
        permission: PermissionsEnum.ResellersManagement
    }, {
        title: 'Members',
        url: MEMBERS_LIST_PATH,
        iconSrc: memberSvg,
        permission: PermissionsEnum.ViewMember
    }, {
        title: 'Servers',
        url: SERVER_LIST_PATH,
        iconSrc: serverSvg,
        permission: PermissionsEnum.ViewServer
    }, {
        title: 'Refunds',
        url: REFUNDS_LIST_PATH,
        iconSrc: reloadSvg,
        permission: PermissionsEnum.ViewRefund
    }, {
        title: 'Activity',
        url: ACTIVITY_LIST_PATH,
        iconSrc: activitySvg,
        permission: PermissionsEnum.ViewActivityLog
    }, {
        title: 'Custom plans',
        url: PLANS_LIST_PATH,
        iconSrc: plansSvg,
        permission: [PermissionsEnum.ViewDirectPlansAndPackages, PermissionsEnum.ViewPartnerPlansAndPackages]
    }, {
        title: 'Coupons',
        url: "".concat(COUPONS_LIST_PATH, "?filters[coupons.status]=active"),
        iconSrc: couponsSvg,
        permission: PermissionsEnum.ViewCoupon
    }, {
        title: 'User management',
        url: USERS_MANAGEMENT_PATH,
        iconSrc: adminsSvg,
        permission: PermissionsEnum.ViewUsers
    }, {
        iconSrc: 'images/global/icons/16/close.svg',
        className: 'sidebar-bottom',
        title: 'Log out',
        url: LOGOUT
    }].map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
        'data-testid': 'left-sidebar-link'
    });
});
